import * as React from 'react';
import * as s from './Hamburger.module.scss';
import {
  disableBodyScrolling,
  enableBodyScrolling,
  getBrowser,
} from '../../libs/utils';

interface Props {
  button?: React.ReactNode;
  logo?: {
    top: React.ReactNode;
    topOpen: React.ReactNode;
    fixed: React.ReactNode;
  };
}

class Hamburger extends React.Component<Props> {
  state = {
    isOpen: false,
    showFixedNav: false,
    iOS: false,
    innerHeight: 0,
    desktop: true,
  };

  currentScrollTop = 0;
  scrollEnabled = true;

  componentDidMount() {
    this.handleScroll();
    this.handleResize();
    this.updateDomElements();
    this.setState({ iOS: getBrowser() === 'ios_safari' });
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidUpdate() {
    this.updateDomElements();
  }

  disableScroll = () => {
    this.scrollEnabled = false;
    const { desktop, innerHeight } = this.state;

    this.currentScrollTop = disableBodyScrolling();

    const innerBody = document.getElementById('innerbody');
    if (desktop) {
      innerBody && innerBody.setAttribute('style', '');
    } else {
      innerBody &&
        innerBody.setAttribute(
          'style',
          `position: relative; height: ${innerHeight}px;`
        );
    }
  };

  enableScroll = () => {
    this.scrollEnabled = true;
    const { desktop } = this.state;

    const innerBody = document.getElementById('innerbody');
    if (desktop) {
      innerBody && innerBody.setAttribute('style', '');
    } else {
      innerBody &&
        innerBody.setAttribute('style', 'position: initial; height: 100%');
    }

    enableBodyScrolling(this.currentScrollTop);
  };

  updateDomElements = () => {
    const { isOpen } = this.state;

    if (isOpen && this.scrollEnabled) {
      this.disableScroll();
    } else if (!isOpen && !this.scrollEnabled) {
      this.enableScroll();
    }
  };

  handleResize = () => {
    const currentHeight = window.innerHeight;
    const currentIsDesktop =
      typeof window !== 'undefined' && window.innerWidth > 768;

    if (this.state.desktop !== currentIsDesktop) {
      this.setState({ desktop: currentIsDesktop });
    }

    if (this.state.innerHeight !== currentHeight) {
      this.setState({ innerHeight: currentHeight });
    }
  };

  handleScroll = () => {
    const currentScrollPos = window.pageYOffset;
    const visible = currentScrollPos >= 120; // 120 is the height of the top navbar

    this.setState({
      showFixedNav: visible,
    });
  };

  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  close = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen, showFixedNav, iOS, desktop } = this.state;
    const { logo, button, children } = this.props;
    let topIcon = null;

    if (desktop) {
      if (isOpen) {
        topIcon = logo.topOpen;
      } else {
        topIcon = logo.top;
      }
    } else {
      topIcon = logo.top;
    }

    return (
      <div className={s.outerWrapper}>
        {/* Top Position */}
        <div className={[s.navbar, isOpen ? s.open : ''].join(' ')}>
          {topIcon}
          <button
            className={[s.burger, isOpen ? s.open : ''].join(' ')}
            onClick={this.toggleOpen}
          >
            {button || (
              <React.Fragment>
                <div className={s.close}>
                  <div className={s.bar} />
                  <div className={s.bar} />
                </div>
              </React.Fragment>
            )}
          </button>
        </div>

        {/* Fixed Position */}
        <div
          className={[
            s.navbar,
            s.fixedPosition,
            showFixedNav ? s.showFixedNav : '',
            isOpen ? s.open : '',
          ].join(' ')}
        >
          {logo.fixed}
          <button
            className={[s.burger, isOpen ? s.open : ''].join(' ')}
            onClick={this.toggleOpen}
          >
            {button || (
              <React.Fragment>
                <div className={s.close}>
                  <div className={[s.bar, s.fixedPosition].join(' ')} />
                  <div className={[s.bar, s.fixedPosition].join(' ')} />
                </div>
              </React.Fragment>
            )}
          </button>
        </div>
        <div
          className={[s.wrapper, isOpen ? s.open : '', iOS ? s.iOS : ''].join(
            ' '
          )}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Hamburger;
